import React from 'react';

const TextArea = ({
  label,
  name,
  placeholder,
  value,
  onChange,
  required = false,
}) => {
  return (
    <div className="form-group mb-4">
      {label && (
        <label htmlFor={name} className="form-label">
          {label}
        </label>
      )}
      <textarea
        id={name}
        name={name}
        className="form-control"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required={required}
        rows={4}
      />
    </div>
  );
};

export default TextArea;
